

@if (showError) {
  <div class="row on-error page-active">
    <div class="col-lg-12"> &nbsp;<br>
      <div class="alert alert-danger col-md-12 col-lg-6" role="alert" [innerHTML]="error_message"></div>
    </div>
  </div>
}

@if (!showError) {
  <div>
    <div class="row">
      <div class="col-sm-12 mb-3">
        <h1 class="mb-3">Success</h1>
        <div class="alert alert-dark text-white p-4 col-sm-12 col-md-6 col-lg-4" role="alert">
          <i class="fas fa-check-circle"></i> Thank you for applying
        </div>
        <br/>
        <p>Approved payment arrangement requests will receive either an email or text confirmation within 3 business days.</p>
        <p>When you set up your plan, and each time you change it, we will send you a payment schedule with:</p>
        <ul>
          <li>the number of payments you need to make to pay off any debt on your account</li>
          <li>how long you will be making payments</li>
          <li>the amount and due date of each payment.</li>
        </ul>
        <p>If you miss a payment due date, we'll contact you to revise your payment plan and help you get back on track.</p>
        <p>Your privacy is important us. For informaton on how we protect the personal information we collect, access our Privacy Collection Notice and Privacy Policy on our Privacy Page. By submitting this form, you confirm you have read and understood the <a href="https://www.urbanutilities.com.au/about-us/corporate-information/privacy/privacy-collection-notice">Privacy Collection Notice</a> and <a href="https://urbanutilities.com.au/sfsites/c/cms/delivery/media/MCNCUR7MKIOBFKBPFFSKRW3JIX6I">Privacy Policy</a>.</p>
        <p>For further information please email <a href="mailto:customerservice@urbanutilities.com.au">customerservice&#64;urbanutilities.com.au</a> or visit the Urban Utilities website.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12 mb-3">
        <div class="form-group">
          <button class="btn btn-primary rounded-pill" (click)="backToMainMenu()">Return to main menu</button>
        </div>
      </div>
    </div>
    <div class="row" style="padding-bottom: 50px;">
      <div class="col-sm-12 mb-3">
        <h4>Any questions?</h4>
        <p><a target="_blank" href="https://www.urbanutilities.com.au/contact-us/faqs" class="click-me" id="faq-link">Check out our FAQs.</a> You can also chat with us on during the week: on <a target="_blank" href="https://www.urbanutilities.com.au/contact-us">webchat</a> from 7am-7pm or phone <a href="tel:132657" class="click-me" id="phone-link">13&nbsp;26&nbsp;57</a>, 8am-5pm weekdays.</p>
      </div>
    </div>
  </div>
}